import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('title'),
	fieldsMap.get('active_status'),
	fieldsMap.get('short_description'),
	fieldsMap.get('description'),
	fieldsMap.get('things_to_do')
];

const config: IFormConfig = {
	fields: formFields 
};

export default config;
